import { BsList } from "react-icons/bs";
import { SlArrowLeft } from "react-icons/sl";
import {
  PiCaretDown,
  PiCaretUp
} from "react-icons/pi";
import { useContext, useEffect, useState, useRef } from "react";
import menuData from "./menuData";
import Categorie from "./Categorie";
import { useTheme } from "../../context/ThemeContext";
import HoldingSelector from "../HoldingSelector/HoldingSelector";
import { CSSTransition, SwitchTransition } from "react-transition-group";
import { NavLink, Link } from "react-router-dom";
import { AuthContext } from "../../context/AuthContext";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

/**
 * Composant pour afficher la SideBar de l'ECP
 * @param {boolean} sideOpen - pour basculer l'état de la barre latérale
 * @param {function} setSideOpen - pour changer la valeur de sideOpen
 */

export default function Sidebar({ sideOpen, setSideOpen, setEntrepriseName }) {
  const { theme } = useTheme();
  const [activeBtn, setActiveBtn] = useState(null);
  const [secondDrop, setSecondDrop] = useState(null);
  const [thirdDrop, setThirdDrop] = useState(null);
  const [showCategorie, setShowCategorie] = useState(false);
  const [categorieStyle, setCategorieStyle] = useState(null);
  const [titleStyle, setTitleStyle] = useState(null);
  const location = useLocation();
  const [activeCategoryIndex, setActiveCategoryIndex] = useState(null);
  const burgerRef = useRef(null);
  const { t } = useTranslation();
  const { user } = useContext(AuthContext);

  function hasMatchingRoles(userRoles, requiredRoles) {
    if (!requiredRoles || requiredRoles.length === 0) return true; // si aucun rôle requis, on affiche
    return requiredRoles.some(role => userRoles.includes(role));
  }

  //Gérer l'affiche et l'animation de la sidebar
  useEffect(() => {
    if (!sideOpen) {
      setShowCategorie(false);
      setTitleStyle({ transition: "none" })
      setCategorieStyle({ transition: "none" });
    } else {
      setShowCategorie({ left: null });
    }
  }, [sideOpen]);

  useEffect(() => {
    const currentPath = location.pathname;

    menuData.forEach((menu, index) => {
      if (menu.directlyLink && menu.path === currentPath) {
        setActiveCategoryIndex(index);
        return;
      }

      if (menu.category) {
        const found = menu.category.some(category => {
          if (category.path && category.path === currentPath) return true;
          if (category.submenu) {
            return category.submenu.some(sub => sub.path === currentPath);
          }
          return false;
        });

        if (found) {
          setActiveCategoryIndex(index);
        }
      }
    });
  }, [location.pathname]);


  // Gérer le niveau du menu
  const handleactiveBtn = (id) => {
    if (activeBtn !== null) {
      setTitleStyle(null)
    } else if (activeBtn === null) {
      setTitleStyle({ transition: "none" })
    }
    if (activeBtn !== id) {
      setActiveBtn(id);
      setSideOpen(true);
      setSecondDrop(null);
      setThirdDrop(null);
      setShowCategorie(true);
      setCategorieStyle({ transition: "all 300ms ease-in-out" });
    } else if (activeBtn === id && !sideOpen) {
      setSideOpen(!sideOpen);
    } else if (activeBtn === id && sideOpen) {
      setActiveBtn(null);
      setCategorieStyle({ transition: "all 300ms ease-in-out" });
    }
  };

  // Gérer l'affichage du sous menu
  const handleSecondDrop = (id) => {
    if (secondDrop === id && activeBtn) {
      setSecondDrop(null);
    } else if (secondDrop !== id && activeBtn) {
      setSecondDrop(id);
    }
  };

  // Gérer l'affichage du sous sous menu
  const handleThirdDrop = (id) => {
    if (thirdDrop === id && secondDrop) {
      setThirdDrop(null);
    } else if (secondDrop !== id && secondDrop) {
      setThirdDrop(id);
    }
  };

  return (
    <>
      {user &&
        <nav className="sidebar">
          <div
            className={`sidebar-container ${sideOpen ? "sidebar-container_open" : ""}`}
          >
            <div className="sidebar-header">
              <div className={`sidebar-logo ${sideOpen ? "sidebar-open" : ""}`}>
                <Link to={"/"}>
                  <img src={`${theme === "light" ? "/elitlogo.png" : "../assets/logo_white.png"}`} alt="Logo d'elit-technologies" />
                </Link>
              </div>
              <button
                aria-label="bouton pour ouvrir le menu"
                className={`sidebar-burger ${sideOpen ? "sidebar-burger_open" : ""}`}
                onClick={() => setSideOpen(!sideOpen)}
              >
                <SwitchTransition mode="out-in">
                  <CSSTransition
                    key={sideOpen ? "chevron" : "bars"}
                    timeout={{
                      enter: 40,
                      exit: 0,
                    }}
                    nodeRef={burgerRef}
                    classNames={{
                      enter: "fade-fast-enter",
                      enterActive: "fade-fast-enter-active",
                      exit: "fade-instant-exit",
                      exitActive: "fade-instant-exit-active",
                    }}
                  >
                    <span ref={burgerRef}>
                      {sideOpen ? <SlArrowLeft /> : <BsList />}
                    </span>
                  </CSSTransition>
                </SwitchTransition>
              </button>
            </div>
            <div className="sidebar-lines">
              <span className="sidebar-lines-content"></span>
            </div>
            <div className={`sidebar-content ${activeCategoryIndex ? 'sidebar-content_open' : ''}`}>
              <ul className="sidebar-list">
                {menuData.map((menu, index) => {
                  const shouldDisplay = hasMatchingRoles(user.roles, menu?.role);
                  if (!shouldDisplay || menu.dontDisplay) return null;
                  if (menu.directlyLink) {
                    return (
                      <div key={index} className={`sidebar-list_container ${index === activeCategoryIndex && !sideOpen ? "active-link-sidebar" : ""}`}>
                        <li
                          className={`sidebar-list_item`}
                        >
                          <NavLink to={menu.path} className="sidebar-list_link">
                            <div className="sidebar-list_link-content">
                              {menu.icon}
                              <span
                                className={`sidebar-list_link-title`}
                                style={titleStyle}
                              >
                                {menu.item}
                              </span>
                            </div>
                          </NavLink>
                        </li>
                      </div>

                    );
                  }
                  return (
                    <div key={index} className={`sidebar-list_container ${index === activeCategoryIndex && !sideOpen ? "active-link-sidebar" : ""}`}>
                      <li
                        className={`sidebar-list_item`}
                        onClick={() => handleactiveBtn(`drop${index + 1}btn`)}
                      >
                        <a className={`${activeBtn === `drop${index + 1}btn` && showCategorie ? "sidebar-list_item_active" : ""} sidebar-list_link`}>
                          <div className="sidebar-list_link-content">
                            {menu.icon}
                            <span
                              className={`sidebar-list_link-title`}
                              style={titleStyle}
                            >
                              {t(menu.item)}
                            </span>
                          </div>
                          <span className="sidebar-list_item-icon">{activeBtn === `drop${index + 1}btn` && showCategorie ? <PiCaretUp /> : <PiCaretDown />}</span>
                        </a>
                      </li>
                      <div
                        className={`categorie ${activeBtn === `drop${index + 1}btn` && showCategorie
                          ? "categorie-show"
                          : ""
                          }`}
                        style={categorieStyle}
                      >
                        <ul className="categorie-list">
                          {menu.category.map((category, index) => (
                            <Categorie
                              key={index}
                              category={category}
                              activeBtn={activeBtn}
                              index={index}
                              secondDrop={secondDrop}
                              handleSecondDrop={handleSecondDrop}
                              thirdDrop={thirdDrop}
                              handleThirdDrop={handleThirdDrop}
                            />
                          ))}
                        </ul>
                      </div>
                    </div>
                  );
                })}
              </ul>
            </div>
            <div className="sidebar-lines mt-2">
              <span className="sidebar-lines-content"></span>
            </div>
            <div className="form-choice-holding">
                <HoldingSelector sideOpen={sideOpen} setSideOpen={setSideOpen} setEntrepriseName={setEntrepriseName}/>
            </div>
          </div>
        </nav>
      }
    </>
  );
}